var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoachesCornerNav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 7.25C5.08207 7.25 3.84209 7.76361 2.92785 8.67785C2.01361 9.59209 1.5 10.8321 1.5 12.125C1.5 12.7652 1.6261 13.3991 1.87109 13.9906C2.11608 14.582 2.47517 15.1195 2.92785 15.5721C3.84209 16.4864 5.08207 17 6.375 17C7.01519 17 7.64912 16.8739 8.24058 16.6289C8.83204 16.3839 9.36946 16.0248 9.82215 15.5721C10.2748 15.1195 10.6339 14.582 10.8789 13.9906C11.1239 13.3991 11.25 12.7652 11.25 12.125V10.9325L16.5 9.5V7.25H8.25V8.75H6.75V7.25H6.375ZM8.25 2V5.75H6.75V2H8.25ZM4.7625 5.96C4.26 6.08 3.78 6.26 3.3225 6.5L1.605 4.16L2.82 3.275L4.7625 5.96ZM13.395 4.16L12.24 5.75H10.3875L12.18 3.275L13.395 4.16Z",
    fill: "#535B66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoachesCornerNav);
export default __webpack_public_path__ + "static/media/CoachesCornerNav.703ceaee67c1a99fa9a77531ac882e42.svg";
export { ForwardRef as ReactComponent };